<template>
  <div class="createCurriculumSystem">
    <el-page-header
      content="新增课程"
      @back="$router.push({ path: '/school-home-page/Campuscourses' })"
    >
    </el-page-header>

    <el-form
      class="form-style"
      label-width="100px"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      v-show="active === 0"
      size="small"
      label-position="left"
    >
      <el-form-item label="排序号" required prop="sort_num">
        <el-input-number
          v-model="ruleForm.sort_num"
          :precision="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="课程名称" required prop="curriculum_name">
        <el-input
          v-model="ruleForm.curriculum_name"
          placeholder="请输入名称"
          style="width: 300px"
        ></el-input>
      </el-form-item>

      <el-form-item label="简介" required>
        <el-input
          type="textarea"
          v-model="ruleForm.curriculum_desc"
          placeholder="请输入体系的简介"
          style="width: 300px"
        ></el-input>
      </el-form-item>

      <el-form-item label="所属科目" required prop="subject_id">
        <el-select
          v-model="ruleForm.subject_id"
          placeholder="请选择"
          style="width: 300px"
          filterable
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) of subjectList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="授课类型" required prop="teaching_type">
        <el-select v-model="ruleForm.teaching_type" placeholder="请选择" style="width: 300px">
          <el-option label="面授课" value="1"></el-option>
          <el-option label="直播课" value="2"></el-option>
          <el-option label="录播课" value="3"></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="课程类型" required prop="curriculum_type">
        <el-select
          v-model="ruleForm.curriculum_type"
          placeholder="请选择"
          style="width: 300px"
        >
          <el-option label="体验课" value="1"></el-option>
          <el-option label="常规课" value="2"></el-option>
          <el-option label="短期课" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <label slot="label" style="margin-left: 10px;">难度等级</label>
        <el-rate v-model="ruleForm.difficulty"></el-rate>
      </el-form-item>
      <el-form-item>
        <label slot="label" style="margin-left: 10px;">适合年级</label>

        <el-input
          v-model="ruleForm.for_grade"
          placeholder="请输入适合年级"
          style="width: 300px"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <label slot="label" style="margin-left: 10px;">课程封面</label>

        <el-upload
          action=""
          :http-request="uploadFile"
          :on-remove="handleRemove"
          :on-change="handleChangeFile1"
          :auto-upload="false"
          :limit="1"
          :file-list="ruleForm.imgList"
          list-type="picture"
          style="width: 400px"
        >
          <el-button size="mini" type="primary" plain
            >点击上传<i class="el-icon-upload el-icon--right"></i
          ></el-button>
          <div slot="tip" class="el-upload__tip">
            <span style="color: red">推荐尺寸(520*360)</span>
            只能上传jpg/png文件，且不超过2mb
          </div>
        </el-upload>
      </el-form-item>
    </el-form>

    <!-- <el-form class="form-style" label-width="0px" v-show="active === 1" size="mini">
      <el-form-item>
        <div class="upload" v-for="(item, index) of ruleForm.curriculum_classes_list" :key="index">
          <div class="uploadList">
            <span style="color: red">*</span>
            第{{ index + 1 }}讲：<el-input v-model="item.name" placeholder="请输入名称" style="width: 150px" size="mini"></el-input>
          </div>

          <div class="uploadList">
            师训视频:<el-upload action="" :limit="1" :http-request="uploadFile" :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'video_url_first', index)
              " :on-change="
                (file, fileList) =>
                  handleChangeFile(file, fileList, 'video_url_first', index)
              " :auto-upload="false" :file-list="item.video_url_first || []" style="width: 130px">
              <el-button style="margin-left: 10px" size="mini" type="primary" plain>点击上传</el-button>
            </el-upload>
          </div>
          <div class="uploadList">
            课程视频2：<el-upload action="" :limit="1" :http-request="uploadFile" :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'video_url_second', index)
              " :on-change="
                (file, fileList) =>
                  handleChangeFile(file, fileList, 'video_url_second', index)
              " :auto-upload="false" :file-list="item.video_url_second || []" style="width: 150px">
              <el-button size="mini" type="primary" plain>点击上传</el-button>
            </el-upload>
          </div>
          <div class="uploadList">
            讲义：<el-upload action="" :limit="1" :http-request="uploadFile" :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'teaching_materials_url', index)
              " :on-change="
                (file, fileList) =>
                  handleChangeFile(
                    file,
                    fileList,
                    'teaching_materials_url',
                    index
                  )
              " :auto-upload="false" :file-list="item.teaching_materials_url || []" style="width: 150px">
              <el-button size="mini" type="primary" plain>点击上传</el-button>
            </el-upload>
          </div>
          <div class="uploadList">
            <span style="color: red">*</span>
            PPT：<el-upload action="" :limit="1" :http-request="uploadFile" :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList, 'ppt_url', index)
              " :on-change="
                (file, fileList) =>
                  handleChangeFile(file, fileList, 'ppt_url', index)
              " :auto-upload="false" :file-list="item.ppt_url || []" style="width: 150px">
              <el-button size="mini" type="primary" plain>点击上传</el-button>
            </el-upload>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="section" v-show="active === 3">
      <h2>提交成功</h2>
      <div class="btn">
        <el-button type="success" @click="quit">返回</el-button>
      </div>
    </div>
    <el-dialog title="添加科目" :visible.sync="dialogVisible">
      <el-form class="form-style" label-width="120px" :model="subjectRuleForm" :rules="subjectRules" ref="subjectRuleForm">
        <el-form-item label="名称" required prop="subject_name">
          <el-input v-model="subjectRuleForm.subject_name" placeholder="请输入名称" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="排序号" required prop="sort_num">
          <el-input-number v-model="subjectRuleForm.sort_num" :precision="0"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quitAddSubject('subjectRuleForm')">取 消</el-button>
        <el-button type="primary" @click="addSubject('subjectRuleForm')">确 定</el-button>
      </span>
    </el-dialog> -->
    <div class="btn">
      <el-button size="small" @click="next('ruleForm')" type="primary"
        >保存</el-button
      >
      <el-button size="small" @click="quit">取消</el-button>
    </div>
  </div>
</template>

<script>
import { addSubject, addOrUpdateSchoolSelfCurriculum } from '@/api/educational'
import { getZoneSchoolSubjectList } from '@/api/community'

import uploadFile from '@/config/uploadFileSchool'
export default {
  name: 'create-owncourse',
  data() {
    return {
      uploadFileTime: false,
      dialogVisible: false,
      active: 0,
      subjectList: [],
      ruleForm: {
        difficulty: null,
        for_grade: '',
        subject_id: '',
        teaching_type: '1',
        number_of_courses: 1,
        sort_num: this.$route.query.total + 1,
        curriculum_name: '',
        curriculum_url: [],
        curriculum_classes_list: [],
        curriculum_type: '', //课程类型
        curriculum_desc: '', //课程简介
        imgList: [
          {
            name: '默认图片',
            url:
              'https://wugecdn.steam.fun/resources/static/school_course_cover.jpeg',
          },
        ],
        img_url:
          'https://wugecdn.steam.fun/resources/static/school_course_cover.jpeg', //课程体系缩略图
      },
      subjectRuleForm: {
        subject_name: '',
        sort_num: '',
      },
      rules: {
        curriculum_name: [
          {
            required: true,
            message: '请输入课程名称',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请输入课程名称',
            trigger: 'change',
          },
        ],
        teaching_type: [
          { required: true, message: '请选择类别', trigger: 'change' },
        ],
        number_of_courses: [
          { required: true, message: '请输入课程次数', trigger: 'change' },
        ],
        sort_num: [
          { required: true, message: '请输入排序号', trigger: 'change' },
        ],
        subject_id: [
          { required: true, message: '请选择科目', trigger: 'change' },
        ],
      },
      subjectRules: {
        subject_name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        sort_num: [
          { required: true, message: '请选择活类别', trigger: 'change' },
        ],
      },
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.ruleForm.subject_id = Number(this.$route.query.id)
    }
    this.getZoneSchoolSubjectList()
  },
  methods: {
    handleAddSubject() {
      this.dialogVisible = true
    },
    //查询校区科目权限
    getZoneSchoolSubjectList() {
      getZoneSchoolSubjectList().then((res) => {
        console.log('获得校区科目列表')
        console.log(res)
        this.subjectList = res.subjectList
      })
    },

    // 添加科目
    addSubject(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addSubject({
            subject_name: this.subjectRuleForm.subject_name,
            sort_num: this.subjectRuleForm.sort_num,
            subject_state: 1,
          }).then((res) => {
            this.$message.success('添加科目成功')
            this.ruleForm.subject_id = res.subject_id
            this.getUserSubjectList()
            this.dialogVisible = false
          })
        }
      })
    },
    quitAddSubject(formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
    },
    // 下一步
    next(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addOrUpdateSchoolSelfCurriculum()
        }
      })
    },

    //新建校区课程体系
    addOrUpdateSchoolSelfCurriculum() {
      console.log('提交课程体系参数')
      console.log(this.ruleForm)

      addOrUpdateSchoolSelfCurriculum({
        difficulty: this.ruleForm.difficulty,
        for_grade: this.ruleForm.for_grade,
        title: this.ruleForm.curriculum_name, //体系名称
        subject_id: this.ruleForm.subject_id, //科目id
        teaching_type: this.ruleForm.teaching_type, //授课类型
        sort_num: this.ruleForm.sort_num, //排序号
        curriculum_data_url: '', //课程资料 [{ name: '课程资料1', 'url': 'http://www.baidu.com', sort_num: 1 }]
        curriculum_type: this.ruleForm.curriculum_type, // 课程类型
        curriculum_desc: this.ruleForm.curriculum_desc, //课程描述
        img_url: this.ruleForm.img_url, //课程封面缩略图
      }).then((res) => {
        console.log('新建课程体系')
        console.log(res)
        if (res.is_create) {
          this.$message.success('创建成功')
          this.$router.push({ name: 'Campuscourses' })
        }
      })
    },

    quit() {
      this.$router.push({ name: 'Campuscourses' })
    },
    uploadFile() {},
    handleRemove(file, fileList, status, index) {
      if (status === 'curriculum_url') {
        this.ruleForm.curriculum_url = fileList
      } else {
        this.ruleForm.curriculum_classes_list[index][status] = fileList
      }
    },
    async handleChangeFile(file, fileList, status, index) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status, index)
      }
    },

    //课程体系缩略图
    async handleChangeFile1(file, fileList) {
      console.log('上传课程体系缩略图')
      const nameIndex = file.name.lastIndexOf('.')
      const isAllowedType = ['.jpeg', '.png', '.jpg'].includes(
        file.name.substring(nameIndex)
      )
      // const isAllowedSize = file.size / 1024 < 500 // 小于500kb
      const isAllowedSize = file.size / 1024 / 1024 < 2 // 小于2M

      if (!isAllowedType) {
        this.$message.error('只能上传 JPG/PNG 格式的图片!')
        this.ruleForm.imgList.pop()
      } else if (!isAllowedSize) {
        this.$message.error('上传的图片大小不能超过 2mb!')
        this.ruleForm.imgList.pop()
      }
      if (isAllowedType && isAllowedSize && !this.uploadFileTime) {
        await this.uploadFileOss(fileList, 'img_url')
      }
    },

    async uploadFileOss(list, status, index) {
      this.uploadFileTime = true

      console.log('status')
      console.log(status)

      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('res')
          console.log(res)

          if (status === 'curriculum_url') {
            this.ruleForm.curriculum_url = res
          } else if (status === 'img_url') {
            this.ruleForm.img_url = res[0].url

            console.log('this.ruleForm.img_url')
            console.log(this.ruleForm.img_url)
          } else {
            this.ruleForm.curriculum_classes_list[index][status] = res
          }
          this.uploadFileTime = false
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.createCurriculumSystem {
  background-color: #fff;
  box-sizing: border-box;
  padding-left: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
  margin: 10px;

  .form-style {
    margin-left: 15px;
  }

  .btn {
    margin: 30px 0 20px 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .upload {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    width: 100%;

    .uploadList {
      display: flex;
    }
  }

  .section {
    box-sizing: border-box;
    height: 300px;
    margin: 30px 50px;
    padding: 60px 0 0 0;
    background-color: #fff;
    text-align: center;

    h2 {
      font-size: 24px;
      font-weight: bold;
      color: #67c23a;
      margin-bottom: 10px;
    }

    li {
      list-style: square;
      line-height: 40px;
      font-size: 16px;
    }

    .btn {
      margin-top: 20px;
      font-size: 16px;
    }
  }
}
</style>
